import { useState, useEffect } from "react";
import { SearchContext } from "../index";
import { articleSearch } from "../../Service/ArticleService";
import { useSearchParams } from "react-router-dom";
import { debounce, apiWithAbort } from "../../Constants/utility";
import { handleGainSightEventForSearchResults, KB_WEBSITE_GAINSIGHT_EVENTS, sendGainsightEvent } from "../../gainSightIntegration";

const searchWithAbort = apiWithAbort(articleSearch);

const getSearchArticles = ( { searchTerm, product, onLoad, onSuccess } ) =>{
  const pathParams = {
    searchTerm,
    ...(product && { product })
  };
  
  if (searchTerm.length >= 2) {
    sendGainsightEvent(KB_WEBSITE_GAINSIGHT_EVENTS.KB_SEARCH_SUBMITTED, { search_query: searchTerm });
  }
  
  const startTime = performance.now();
  onLoad(true);
  searchWithAbort(searchTerm, pathParams).then((result) => {
    const endTime = performance.now();
    const latency = Math.round(endTime - startTime);
    const articles = result.data.data.articles;
    
    onSuccess(articles);
    if (articles && articles.length > 0) {
      const top3Slugs = articles.slice(0, 3).map(article => article.slug);
      handleGainSightEventForSearchResults({
        search_query: searchTerm,
        results_count: articles.length,
        top_result_id: articles[0]?.slug || "",
        top_3_result_slugs: top3Slugs,
        search_latency_ms: latency,
      });
    } else {
      sendGainsightEvent(KB_WEBSITE_GAINSIGHT_EVENTS.KB_SEARCH_ZERO_RESULTS, { search_query: searchTerm });
    }
  }).catch( console.warn ).finally(() =>{
    onLoad(false);
  });
};

const debouncedSearch = debounce(getSearchArticles, 300);

export default function ArticleProvider(props) {
  const [searchList, setSearchList] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [ loading, setLoading ] = useState(false);
  const [searchParams] = useSearchParams();
  const productParam = searchParams.get('product');

  useEffect(() => {
    setLoading(false);
    if (searchInput.length === 0) {
      setSearchList(false);
    } else if (searchInput.length > 0) {
      debouncedSearch({ searchTerm: searchInput, product: productParam, onLoad: setLoading, onSuccess: setSearchList });
    }
  }, [searchInput, productParam]);

  return (
    <SearchContext.Provider
      value={{
        searchList,
        setSearchInput,
        setSearchList,
        searchInput,
        triggerSearch: () => debouncedSearch({ searchTerm: searchInput, product: productParam, onLoad: setLoading, onSuccess: setSearchList }),
        loading,
      }}
    >
      {props.children}
    </SearchContext.Provider>
  );
}
